import { trustCopy } from "@/config/branding";
import type { OfferConfig } from "@/types/offer";

export const obligationsExportOffer: OfferConfig = {
  offerId: "obligations-export",
  pipeline: "obligations-export",
  title: "Obligations register",
  subtitle:
    "Upload a regulatory document and we'll extract a structured, decomposed obligations register",
  intro:
    "Upload a single PDF or Word document. We parse it, extract each obligation into its parts (who, must do what, by when, under which condition), and email you a free preview. Pay only to upgrade to the full register (Word report + Excel). Processing is usually under 30 minutes; larger documents can take up to an hour.",
  estimatedDurationLabel: "Typically under 30 minutes; larger documents can take longer",
  pricing: {
    fromPriceLabel: "Free preview on your own document · Full register from €297 excl. VAT",
    priceRangeLabel: "Final quote shown on your preview, based on document size",
    currency: "eur",
  },
  steps: [
    {
      id: "intro",
      type: "statement",
      title: "Extract obligations",
      description:
        "Let RequirementONE parse your document and identify obligations and guidance.",
      ctaLabel: "Get started",
    },
    {
      id: "context",
      type: "textarea",
      title: "Anything we should know?",
      description: "Optional context helps tailor the extraction.",
      placeholder: "e.g. EU AI Act draft regulation, focus on high-risk systems.",
      required: false,
      rows: 3,
      validation: { maxLength: 2000 },
    },
    {
      id: "files",
      type: "fileUpload",
      title: "Upload your document",
      description: "Upload a regulatory document containing obligations and guidance",
      required: true,
      maxFiles: 1,
      allowedFileTypes: [".pdf", ".docx"],
      maxFileSizeMb: 10,
      helpText: trustCopy.uploadHelp,
    },
    {
      id: "email",
      type: "email",
      title: "Where should we send your preview?",
      description: "We'll email you when the preview is ready, with a link to view and upgrade to the full export.",
      placeholder: "you@company.com",
      required: true,
    },
    {
      id: "review",
      type: "review",
      title: "Review and submit",
      submitLabel: "Start extraction",
    },
  ],
};
